(function () {
    const form = document.querySelector('.ow-contact-form');
    if (!form) return;

    const descriptionTextarea = form.querySelector('.ow-contact-input--description');

    function autoResizeTextarea(textarea) {
        if (!textarea) return;

        const computedStyle = getComputedStyle(textarea);
        const minHeight = parseInt(computedStyle.minHeight, 10);
        const maxHeight = parseInt(computedStyle.maxHeight, 10);

        textarea.style.height = `${minHeight}px`;

        const contentHeight = textarea.scrollHeight + 4;

        let finalHeight;
        if (contentHeight < minHeight) {
            finalHeight = minHeight;
        } else if (contentHeight > maxHeight) {
            finalHeight = maxHeight;
        } else {
            finalHeight = contentHeight;
        }

        textarea.style.height = `${finalHeight}px`;
    }

    if (descriptionTextarea) {
        autoResizeTextarea(descriptionTextarea);
        descriptionTextarea.addEventListener('input', function () {
            autoResizeTextarea(this);
        });
    }

    const nameInput = form.querySelector('.ow-contact-input--name');
    const emailInput = form.querySelector('.ow-contact-input--email');
    const phoneInput = form.querySelector('.ow-contact-input--phone');
    const afterSalesSelect = form.querySelector('#afterSalesIssue');
    const productModelSelect = form.querySelector('#productModel');
    const purchasePlatformSelect = form.querySelector('#purchasePlatform');
    const orderIdInput = form.querySelector('.ow-contact-input--order-id');
    const productSnInput = form.querySelector('.ow-contact-input--product-sn');
    const productSnContainer = document.getElementById('productSnContainer');
    const productSnImage = form.querySelector('.ow-product-sn-image');
    const snRequiredMarker = productSnContainer ? productSnContainer.querySelector('.ow-important-svg') : null;

    const showSnValues = ['technical', 'software', 'materials', 'others'];

    function handleAfterSalesChange() {
        if (!afterSalesSelect || !productSnContainer || !productSnInput) return;

        const selectedValue = afterSalesSelect.value;
        const shouldShowSn = showSnValues.includes(selectedValue);

        if (shouldShowSn) {
            productSnContainer.classList.remove('ow-hidden');
            productSnContainer.setAttribute('aria-hidden', 'false');

            productSnInput.setAttribute('aria-required', 'true');
            productSnInput.setAttribute('required', 'required');
            if (snRequiredMarker) snRequiredMarker.style.display = 'inline';

            if (productSnImage) {
                productSnImage.setAttribute('aria-hidden', 'false');
            }
        } else {
            productSnContainer.classList.add('ow-hidden');
            productSnContainer.setAttribute('aria-hidden', 'true');

            productSnInput.removeAttribute('aria-required');
            productSnInput.removeAttribute('required');
            productSnInput.value = '';
            if (snRequiredMarker) snRequiredMarker.style.display = 'none';

            if (productSnImage) {
                productSnImage.setAttribute('aria-hidden', 'true');
            }

            setInvalid(productSnInput, false);
        }
    }

    handleAfterSalesChange();

    if (afterSalesSelect) {
        afterSalesSelect.addEventListener('change', handleAfterSalesChange);
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function setInvalid(el, isInvalid) {
        if (!el) return;
        el.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        if (!window.customer) {
            // 未登录时跳转到登录页
            window.location.href = '/account/login';
            return;
        }

        [nameInput, emailInput, phoneInput, afterSalesSelect, productModelSelect,
            purchasePlatformSelect, orderIdInput, productSnInput].forEach(function (el) {
                if (el) setInvalid(el, false);
            });


        const nameVal = nameInput ? nameInput.value.trim() : '';
        const emailVal = emailInput ? emailInput.value.trim() : '';
        const phoneVal = phoneInput ? phoneInput.value.trim() : '';
        const afterSalesVal = afterSalesSelect ? afterSalesSelect.value : '';
        const productModelVal = productModelSelect ? productModelSelect.value : '';
        const purchasePlatformVal = purchasePlatformSelect ? purchasePlatformSelect.value : '';
        const productSnVal = productSnInput ? productSnInput.value.trim() : '';

        if (!nameVal) {
            setInvalid(nameInput, true);
            nameInput?.focus();
            return;
        }

        if (!emailVal || !emailRegex.test(emailVal)) {
            setInvalid(emailInput, true);
            emailInput?.focus();
            return;
        }

        if (!afterSalesVal) {
            setInvalid(afterSalesSelect, true);
            afterSalesSelect?.focus();
            return;
        }

        if (!productModelVal) {
            setInvalid(productModelSelect, true);
            productModelSelect?.focus();
            return;
        }

        if (!purchasePlatformVal) {
            setInvalid(purchasePlatformSelect, true);
            purchasePlatformSelect?.focus();
            return;
        }

        if (showSnValues.includes(afterSalesVal) && !productSnVal) {
            setInvalid(productSnInput, true);
            productSnInput?.focus();
            return;
        }
        
    });

    [nameInput, emailInput, phoneInput, orderIdInput, productSnInput].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', function () {
            if (el.getAttribute('aria-invalid') === 'true') {
                setInvalid(el, false);
            }
        });
    });

    [afterSalesSelect, productModelSelect, purchasePlatformSelect].forEach(function (el) {
        if (!el) return;
        el.addEventListener('change', function () {
            if (el.getAttribute('aria-invalid') === 'true') {
                setInvalid(el, false);
            }
        });
    });
})();